import React, { PropsWithChildren } from 'react'
import { ISbRichtext } from 'storyblok-js-client'
import renderRichText from '../../../utils/richTextResolver'
import classes from './headerOptionTwo.module.scss'

export type HeaderOptionTwoProps = {
  component: string
  sub_title: string
  title: string
  description: ISbRichtext
}

const HeaderOptionTwo: React.FC<PropsWithChildren<HeaderOptionTwoProps>> = ({ sub_title, title, description }) => {
  return (
    <div className={classes.headerOptionOneContainer}>
      <div className={classes.headerOptionTwoWrapper}>
        {sub_title !== '' ? (<h4 className={classes.subTitle}>{sub_title}</h4>) : null}
        {title !== '' ? (<h1 className={classes.title}>{title}</h1>) : null}
        {title !== '' ? (
          <div
            className={classes.description}
            dangerouslySetInnerHTML={{ __html: renderRichText(description) }}
          >
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default HeaderOptionTwo
